import React, { useSyncExternalStore } from 'react'
import { useTheme, Stack } from '@mui/material'
import { Tooltip, TooltipProps } from 'recharts'
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent'
import { LineChartStore } from 'src/Libs/ai-360/store'

const ToolTipAI360: React.FC = () => {
  const theme = useTheme()

  const { defaultDataIndex } = useSyncExternalStore(LineChartStore.subscribe, LineChartStore.get)

  const customContent = ({ active, payload, label }: TooltipProps<ValueType, NameType>): JSX.Element => {
    const isVisible = active && payload && payload.length > 0

    return <Stack className="custom-tooltip" style={{ visibility: isVisible ? 'visible' : 'hidden' }} />
  }

  return (
    <Tooltip cursor={{ stroke: theme.palette.grey.grey00, strokeWidth: 2 }} content={customContent} defaultIndex={defaultDataIndex ?? undefined} />
  )
}

export default ToolTipAI360
